import {array, Callback, Mix} from "../Core/Reflection";
import {Sprite} from "../Core/Sprite";
import {HoverableButton, TextureButton} from "../Core/Button";
import {Focusable} from "./Focusable";
import {PulsatingButton} from "./Button";
import {Times} from "../Core/Signal";
import {AudioChannel} from "../Core/AudioChannel";

export class Door extends Mix(TextureButton, HoverableButton([1.02, 1]), PulsatingButton, Focusable) {

    public readonly frames = array(() => new Sprite());
    private isOpen = false;

    openSfx?: string;
    closeSfx?: string;

    onLayout() {
        const s = this.sprite;
        this.hitArea = new PIXI.Rectangle(-s.anchor.x * s.width, -s.anchor.y * s.height, s.width, s.height);
    }

    open(cb?: Callback | "instantly") {
        if (!this.isOpen) {
            if (this.openSfx && cb !== "instantly") AudioChannel.SFX.play(this.openSfx);
            this.isOpen = true;
            this.play([this.sprite, ...this.frames], cb);
        } else if (typeof cb === "function") {
            cb();
        }
    }

    close(cb?: Callback | "instantly") {
        if (this.isOpen) {
            if (this.closeSfx && cb !== "instantly") AudioChannel.SFX.play(this.closeSfx);
            this.isOpen = false;
            this.play([this.sprite, ...this.frames].reverse(), cb);
        } else if (typeof cb === "function") {
            cb();
        }
    }

    private play(frames: Sprite[], cb?: Callback | "instantly") {
        if (cb === "instantly") {
            this.visuals.removeChildren();
            this.visuals.addChild(frames[frames.length - 1]);
        } else {
            let d = 0;
            const t = 0.1;
            if (cb) cb = Times(frames.length, cb);
            for (const frame of frames) {
                this.delayedCall(d, () => {
                    this.visuals.removeChildren();
                    this.visuals.addChild(frame);
                    if (typeof cb === "function") cb();
                });
                d += t;
            }
        }
    }
}

export class Freezer extends Door {

    readonly hoverScale = 1.05;
    readonly downScale = 1;
}

export class Oven extends Door {

    readonly hoverScale = 1.05;
    readonly downScale = 1;

    constructor() {
        super();

        this.openSfx = "oven-open";
        this.closeSfx = "oven-close";
    }
}